module.exports = __webpack_public_path__ + "media/applicants/cbs-2e1a1fa5.jpg";